import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Box, Stack } from '@mui/material';
import SuppliersTable from '../components/SuppliersTable';
import TopBar from '../../../components/TopBar';
import SupplierListPageActions from '../components/SupplierListPageActions';
import useSupplierFilters from '../components/SupplierFilterHelper';
import SupplierListFilters from '../components/SupplierListFilters';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

function SupplierListPage() {
  const { suppliers: s } = useTranslatedMessages();

  const filters = [
    {
      type: 'search',
      options: [
        {
          key: 'name',
          placeholder: s?.pages?.list?.filters?.placeholders?.name || 'Supplier Name',
        },
        {
          key: 'company_id',
          placeholder: s?.pages?.list?.filters?.placeholders?.vat_number || 'VAT Number',
        },
        {
          key: 'email',
          placeholder: s?.pages?.list?.filters?.placeholders?.email || 'Email',
        },
      ],
    },
  ];

  useDocumentTitle(s?.pages?.list?.document_title || 'Supplier List');

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  } = useSupplierFilters({ defaultQuery: {}, searchOnChange: true, persistKey: 'suppliers' });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title={s?.pages?.list?.top_bar_title || 'Suppliers'}>
        <SupplierListPageActions />
      </TopBar>
      <Box mb={2}>
        <SupplierListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          searchPlaceholder={s?.pages?.list?.filters?.search_placeholder || 'Search...'}
        />
      </Box>
      <SuppliersTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default SupplierListPage;
